import { Icon } from "@iconify/react";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./CsvUploader.scss";
import muteFill from "../../../assets/icons/muteFill.svg";
import microphone from "../../../assets/icons/microphone.svg";
import dialerPhone from "../../../assets/icons/dialerPhone.svg";
import callingAIIcon from "../../../assets/icons/callingAIIcon.svg";
import personCalling from "../../../assets/icons/personCalling.svg";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { flask_url } from "../../../Socket";

const CsvUploader = ({ setCsvData, agentNumbers, getLoader, setCustomerData, customerData, checkNumber, getNumberInput }) => {
  const [isloading, setisloading] = useState(true);
  const [csvFile, setCsvFile] = useState(null);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [showCall, setShowCall] = useState(false);
  const [calling, setCalling] = useState(true);
  const [callPick, setCallPick] = useState(true);

  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [loading, setLoading] = useState(false);
  const [emptyInput, setEmptyInput] = useState(false);
  const [disabled, setDisabled] = useState(false);

  // const [csvData, setCsvData] = useState(null);

  const styles = {
    // ... existing styles ...
    uploadButton: {
      padding: "10px",
      backgroundColor: "#4CAF50",
      color: "white",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
    },

    uploadedButton: {
      backgroundColor: "red", // Change to the desired background color
    },
  };

  const handleCallEnd = () => {
    setCallPick(false);
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setSeconds((prevSeconds) => {
        if (prevSeconds === 59) {
          setMinutes((prevMinutes) => {
            if (prevMinutes === 59) {
              setHours((prevHours) => prevHours + 1);
              return 0;
            }
            return prevMinutes + 1;
          });
          return 0;
        }
        return prevSeconds + 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const padZero = (value) => (value < 10 ? `0${value}` : value);
  // Calling Timer End
  const navigate = useNavigate();

  // const handleFileChange = (e) => {
  //   const file = e.target.files[0];
  //   setCsvFile(file);
  // };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setCsvFile(file);

    // Read the content of the CSV file
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const content = e.target.result;
        // Parse the CSV content (You may need a CSV parsing library)
        // For simplicity, let's assume that CSV is a comma-separated file
        const parsedData = content.split("\n").map((row) => row.split(","));
        setCsvData(parsedData);
        
      };
      reader.readAsText(file);
    }
  };

  const handleShowCall = () => {
    setShowCall(true);
  };
  // ----------------------------------------------------
  const handleUpload = () => {
    if (!checkNumber) {
      toast.error("Please enter at least one number and name of agent");
      return;
    }

    if (csvFile) {
      const formData = new FormData();
      formData.append("file", csvFile, csvFile.name);

      setDisabled(true);

      fetch(`${flask_url}/upload`, {
        method: "POST",
        body: formData,
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaa :", data);

          toast.success("File Uploaded");
          // setUploadSuccess(true);
          setCustomerData(data?.customers);
          setAfterUpload(true);
          // sendLoader();
        })
        .catch((error) => {
          toast.error("Opps Something Went Wrong");
          console.error("Error uploading file:", error);
        })
        .finally(() => {
          setDisabled(false);
        });
    } else {
      toast.error("Please Select a File");
    }
  };

  const cancelUpload = () => {
    setCsvFile(false);
  };

  const sendLoader = () => {
    getLoader(true);
  };

  const handleEmptyInput = () => {
    getNumberInput(true);
  };

  const [afterUpload, setAfterUpload] = useState(null);

  return (
    <>
      {!showCall ? (
        <div className="fileUpload-container">
          {/* {loading ? (
            <LoaderScreen />
          ) : ( */}
          <div className="fileUpload-centered-container">
            {!uploadSuccess ? (
              <>
                {!csvFile && (
                  <>
                    <h5 className="pb-3">
                      Click on <span style={{ color: "#AB9B5D", fontWeight: "500" }}>upload CSV file</span> icon to start calling
                    </h5>
                    <label htmlFor="file" className="pointer">
                      <Icon icon="ep:upload-filled" color="#4CAF50" width="100" height="100" />
                    </label>
                    <input id="file" type="file" accept=".csv" onChange={handleFileChange} className="d-none" style={styles.fileInput} />
                  </>
                )}
                {/* <Link to="/loader"> */} {/* onClick={handleUpload } */}
                {!afterUpload && csvFile && (
                  <>
                    <div className="pb-3">
                      <h5 className="pb-3">
                        Click on <span style={{ color: "#AB9B5D", fontWeight: "500" }}>upload button</span> to upload file
                      </h5>
                      <div className="upload-divcross">
                        <Icon icon="basil:cross-solid" className="cross-csv-upload" onClick={cancelUpload} />
                        <button
                          onClick={() => {
                            handleUpload();
                            // loaderFunction();
                            // sendLoader();
                          }}
                          style={styles.uploadButton}
                          disabled={disabled}
                        >
                          Upload
                        </button>
                      </div>
                    </div>
                  </>
                  // ) : (
                  //   <>
                  //     <div>File Uploaded Successfully</div>
                  //   </>
                )}
                {afterUpload && <div className="fileUploadedSuccess-font pb-3">File Uploaded Successfully</div>}
              </>
            ) : (
              <>
                {/* <h5 className="pb-3">
                  Click on <span style={{ color: "#AB9B5D", fontWeight: "500" }}>start call</span> for calling{" "}
                </h5>
                <button
                  style={styles.startButton}
                  onClick={() => {
                    // handleCallConnecting();
                    handleShowCall();
                  }}
                >
                  Start Call
                </button> */}
              </>
            )}
          </div>
          {/* )} */}
        </div>
      ) : (
        <>
          <div className="dialerCalling-main-container">
            <div className="dialerCalling-header">
              <h2>Concrete Restoration</h2>
              <span></span>
            </div>
            <div className="dialerCalling-center">
              <div className="dialerCalling-center-box">
                {callPick ? (
                  <div className="AI-bot-box-parent">
                    <div className="AI-bot-box">
                      <img src={callingAIIcon} alt="" />
                    </div>
                    <div id="bars">
                      <div class="bar"></div>
                      <div class="bar"></div>
                      <div class="bar"></div>
                      <div class="bar"></div>
                      <div class="bar"></div>
                      <div class="bar"></div>
                      <div class="bar"></div>
                      <div class="bar"></div>
                      <div class="bar"></div>
                      <div class="bar"></div>
                      <div class="bar"></div>
                      <div class="bar"></div>
                      <div class="bar"></div>
                      <div class="bar"></div>
                      <div class="bar"></div>
                    </div>
                    <div className={`Person-bot-box ${!calling ? "Person-bot-box-shadow" : ""} `}>
                      <img src={personCalling} alt="" />
                    </div>
                  </div>
                ) : (
                  <div className="d-flex flex-column justify-content-center align-items-center">
                    <div className="Person-bot-box">
                      <img src={personCalling} alt="" />
                    </div>
                    <div className="counter-container d-flex">
                      <div className="counter" id="hours">
                        00
                      </div>
                      <div className="colon">:</div>
                      <div className="counter" id="minutes">
                        02
                      </div>
                      <div className="colon">:</div>
                      <div className="counter" id="seconds">
                        15
                      </div>
                    </div>
                  </div>
                )}
              </div>
              {calling ? (
                <h4>Calling. . . .</h4>
              ) : callPick ? (
                <div className="counter-container d-flex">
                  <div className="counter" id="hours">
                    {padZero(hours)}
                  </div>
                  <div className="colon">:</div>
                  <div className="counter" id="minutes">
                    {padZero(minutes)}
                  </div>
                  <div className="colon">:</div>
                  <div className="counter" id="seconds">
                    {padZero(seconds)}
                  </div>
                </div>
              ) : (
                <></>
              )}
              <p className="numQueue-txt">Next Number in Queue</p>
              <p className="numQueue-number">+16102347269</p>
            </div>
            <div className="dialerCalling-bottom">
              <div className="dailerCalling-bottom-options">
                <div>
                  <img src={muteFill} alt="" />
                </div>
                <div>
                  <img src={microphone} alt="" />
                </div>
                <div
                  onClick={() => {
                    handleCallEnd();
                  }}
                >
                  <img src={dialerPhone} alt="" />
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      <ToastContainer />
    </>
  );
};

export default CsvUploader;
